// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-container {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  max-width: 1000px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
}

.modal-header {
  margin-bottom: 20px;
  display: none;
}

.modal-title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 8px;
}

.modal-subtitle {
  color: #666;
  margin-bottom: 20px;
}

.current-image-section {
  margin-bottom: 30px;
  border: 1px solid #eee;
  padding: 20px;
  border-radius: 8px;
  background: #fff;
}

.modal-content-grid {
  display: grid;
  grid-template-columns: minmax(300px, 1fr) 1.5fr;
  gap: 25px;
  align-items: start;
}

.current-image-wrapper {
  border: 1px solid #eee;
  padding: 15px;
  border-radius: 8px;
  background: #fafafa;
}

.current-image-wrapper img {
  max-height: 300px;
  width: auto;
  display: block;
  margin: 0 auto;
  object-fit: contain;
}

.current-card-info {
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  /* height: 100%; */
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  display: flex;
  flex-direction: column;
  /* gap: 15px; */
}

.card-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  padding-bottom: 10px;
  border-bottom: 2px solid #eee;
}

.card-subtitle {
  font-size: 17px;
  color: #555;
  margin: 10px 0;
  line-height: 1.4;
}

.card-description {
  font-size: 15px;
  line-height: 1.6;
  color: #444;
  white-space: pre-line;
  flex-grow: 1;
  overflow-y: auto;
  max-height: 200px;
  padding-right: 10px;
}

.card-description::-webkit-scrollbar {
  width: 8px;
}

.card-description::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.card-description::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

.card-description::-webkit-scrollbar-thumb:hover {
  background: #999;
}

.variations-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  margin-bottom: 20px;
}

@media (min-width: 768px) {
  .variations-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

.variation-item {
  border: 2px solid #ddd;
  border-radius: 4px;
  padding: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.variation-item:hover {
  border-color: #999;
}

.variation-item.selected {
  border-color: #0066cc;
  box-shadow: 0 0 10px rgba(0, 102, 204, 0.2);
}

.variation-item img {
  width: 100%;
  height: 200px;
  object-fit: contain;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.modal-button {
  padding: 8px 16px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  font-weight: 500;
}

.cancel-button {
  background-color: #f0f0f0;
  color: #333;
}

.cancel-button:hover {
  background-color: #e0e0e0;
}

.apply-button {
  background-color: #0066cc;
  color: white;
}

.apply-button:hover {
  background-color: #0052a3;
}

.apply-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/css/ImageSelectionModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-container {\n  background-color: white;\n  padding: 20px;\n  border-radius: 8px;\n  width: 90%;\n  max-width: 1000px;\n  max-height: 90vh;\n  overflow-y: auto;\n  position: relative;\n}\n\n.modal-header {\n  margin-bottom: 20px;\n  display: none;\n}\n\n.modal-title {\n  font-size: 1.5rem;\n  font-weight: bold;\n  margin-bottom: 8px;\n}\n\n.modal-subtitle {\n  color: #666;\n  margin-bottom: 20px;\n}\n\n.current-image-section {\n  margin-bottom: 30px;\n  border: 1px solid #eee;\n  padding: 20px;\n  border-radius: 8px;\n  background: #fff;\n}\n\n.modal-content-grid {\n  display: grid;\n  grid-template-columns: minmax(300px, 1fr) 1.5fr;\n  gap: 25px;\n  align-items: start;\n}\n\n.current-image-wrapper {\n  border: 1px solid #eee;\n  padding: 15px;\n  border-radius: 8px;\n  background: #fafafa;\n}\n\n.current-image-wrapper img {\n  max-height: 300px;\n  width: auto;\n  display: block;\n  margin: 0 auto;\n  object-fit: contain;\n}\n\n.current-card-info {\n  padding: 20px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  /* height: 100%; */\n  box-shadow: 0 2px 4px rgba(0,0,0,0.05);\n  display: flex;\n  flex-direction: column;\n  /* gap: 15px; */\n}\n\n.card-title {\n  font-size: 20px;\n  font-weight: bold;\n  color: #333;\n  padding-bottom: 10px;\n  border-bottom: 2px solid #eee;\n}\n\n.card-subtitle {\n  font-size: 17px;\n  color: #555;\n  margin: 10px 0;\n  line-height: 1.4;\n}\n\n.card-description {\n  font-size: 15px;\n  line-height: 1.6;\n  color: #444;\n  white-space: pre-line;\n  flex-grow: 1;\n  overflow-y: auto;\n  max-height: 200px;\n  padding-right: 10px;\n}\n\n.card-description::-webkit-scrollbar {\n  width: 8px;\n}\n\n.card-description::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.card-description::-webkit-scrollbar-thumb {\n  background: #ccc;\n  border-radius: 4px;\n}\n\n.card-description::-webkit-scrollbar-thumb:hover {\n  background: #999;\n}\n\n.variations-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 15px;\n  margin-bottom: 20px;\n}\n\n@media (min-width: 768px) {\n  .variations-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n.variation-item {\n  border: 2px solid #ddd;\n  border-radius: 4px;\n  padding: 10px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.variation-item:hover {\n  border-color: #999;\n}\n\n.variation-item.selected {\n  border-color: #0066cc;\n  box-shadow: 0 0 10px rgba(0, 102, 204, 0.2);\n}\n\n.variation-item img {\n  width: 100%;\n  height: 200px;\n  object-fit: contain;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n  padding-top: 20px;\n  border-top: 1px solid #eee;\n}\n\n.modal-button {\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: none;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.cancel-button {\n  background-color: #f0f0f0;\n  color: #333;\n}\n\n.cancel-button:hover {\n  background-color: #e0e0e0;\n}\n\n.apply-button {\n  background-color: #0066cc;\n  color: white;\n}\n\n.apply-button:hover {\n  background-color: #0052a3;\n}\n\n.apply-button:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
